import * as React from 'react';
import { StyleSheet, View } from 'react-native';
import { CardView, rem } from 'design-system';
import SectionHeader from 'design-system/SectionHeader';
import { SettingsItemSwitch } from 'design-system/SettingsItem';
import { useAppSelector } from 'store/hooks';
import { selectFeatureFlag } from 'reducers/selectors';
import { useNotificationsPreferences } from 'features/settings/notifications/hooks/useNotificationsPreferences';
const InvestingSection = () => {
    const { updatePreferences, isUpdating } = useNotificationsPreferences(false);
    const dividendReinvestingConfig = useAppSelector((store) => store.user.preferences?.['stocks.dividend_reinvest'])?.value;
    const [state, setState] = React.useState({
        dividendReinvesting: dividendReinvestingConfig,
    });
    React.useEffect(() => {
        if (!isUpdating) {
            setState({
                dividendReinvesting: dividendReinvestingConfig,
            });
        }
    }, [dividendReinvestingConfig, isUpdating]);
    const onValueChange = React.useCallback((newValue) => {
        setState({ dividendReinvesting: newValue });
        updatePreferences({ 'stocks.dividend_reinvest': newValue });
    }, [updatePreferences]);
    return (<View testID="InvestingSection">
      <SectionHeader horizontalMargins style={styles.sectionHeader}>
        Investing
      </SectionHeader>
      <CardView noMarginTop noMarginBottom>
        <SettingsItemSwitch title="Dividend reinvesting" onValueChange={onValueChange} value={state.dividendReinvesting} description="Automatically reinvest your dividends and buy shares of the same company"/>
      </CardView>
    </View>);
};
const InvestingSectionWrapper = () => {
    const hasDividendReinvesting = useAppSelector((store) => selectFeatureFlag(store, 'dividend_reinvest').value);
    if (hasDividendReinvesting) {
        return <InvestingSection />;
    }
    return null;
};
const styles = StyleSheet.create({
    sectionHeader: {
        marginTop: rem(8),
        marginBottom: rem(16),
    },
});
export default React.memo(InvestingSectionWrapper);
